import React, { Component } from 'react';

// Since Create React App 2.0, you can load SVGs as React Components
import { ReactComponent as AlcopopBottle } from './icons/alcopop-bottle.svg';
import { ReactComponent as ArrowLeft } from './icons/arrow-left.svg';
import { ReactComponent as ArrowRight } from './icons/arrow-right.svg';
import { ReactComponent as Availability } from './icons/availability.svg';
import { ReactComponent as Beer } from './icons/beer.svg';
import { ReactComponent as CanSmall } from './icons/can-small.svg';
import { ReactComponent as CanLarge } from './icons/can-large.svg';
import { ReactComponent as Crime } from './icons/crime.svg';
import { ReactComponent as Health } from './icons/health.svg';
import { ReactComponent as Marketing } from './icons/marketing.svg';
import { ReactComponent as People } from './icons/people.svg';
import { ReactComponent as PreventingHarms } from './icons/preventing-harms.svg';
import { ReactComponent as Research } from './icons/research.svg';
import { ReactComponent as Shot } from './icons/shot.svg';
import { ReactComponent as Society } from './icons/society.svg';
import { ReactComponent as Support } from './icons/support.svg';
import { ReactComponent as Treatment } from './icons/treatment.svg';
import { ReactComponent as Trends } from './icons/trends.svg';
import { ReactComponent as WineBottle } from './icons/wine-bottle.svg';
import { ReactComponent as WineLarge } from './icons/wine-large.svg';
import { ReactComponent as FortWineLarge } from './icons/fort-wine-large.svg';
import { ReactComponent as FortWineSmall } from './icons/fort-wine-small.svg';
import { ReactComponent as WineMed } from './icons/wine-med.svg';
import { ReactComponent as WineSmall } from './icons/wine-small.svg';

class Icon extends Component {
  render() {
    switch (this.props.name) {
      case 'alcopop-bottle':
        return <AlcopopBottle {...this.props} />;
      case 'arrow-left':
        return <ArrowLeft {...this.props} />;
      case 'arrow-right':
        return <ArrowRight {...this.props} />;
      case 'availability':
        return <Availability {...this.props} />;
      case 'beer':
        return <Beer {...this.props} />;
      case 'can-small':
        return <CanSmall {...this.props} />;
      case 'can-large':
        return <CanLarge {...this.props} />;
      case 'crime':
        return <Crime {...this.props} />;
      case 'fort-wine-large':
        return <FortWineLarge {...this.props} />;
      case 'fort-wine-small':
        return <FortWineSmall {...this.props} />;
      case 'health':
        return <Health {...this.props} />;
      case 'marketing':
        return <Marketing {...this.props} />;
      case 'people':
        return <People {...this.props} />;
      case 'preventing-harms':
        return <PreventingHarms {...this.props} />;
      case 'research':
        return <Research {...this.props} />;
      case 'shot':
        return <Shot {...this.props} />;
      case 'society':
        return <Society {...this.props} />;
      case 'support':
        return <Support {...this.props} />;
      case 'treatment':
        return <Treatment {...this.props} />;
      case 'trends':
        return <Trends {...this.props} />;
      case 'wine-bottle':
        return <WineBottle {...this.props} />;
      case 'wine-large':
        return <WineLarge {...this.props} />;
      case 'wine-med':
        return <WineMed {...this.props} />;
      case 'wine-small':
        return <WineSmall {...this.props} />;
      default:
        return <AlcopopBottle {...this.props} />;
    }
  }
}

export default Icon;
